﻿export class ReCaptchaComponent {
    constructor(selector) {
        const self = this;
        self.selector = selector;
        self.widgetId = null;
        self.token = null;
    }

    initCaptcha(_ReCaptchaSiteKey) {
        const self = this;
        const container = document.querySelector(self.selector);

        if (!container) {
            console.error('ReCaptcha container not found!');
            return;
        }

        // Ensure the reCaptcha API is loaded
        if (typeof grecaptcha === 'undefined') {
            console.warn('reCAPTCHA not loaded yet. Retrying...');
            setTimeout(() => this.initCaptcha(), 100);
            return;
        }

        // Render reCaptcha widget
        try {
            self.widgetId = grecaptcha.render(container, {
                sitekey: _ReCaptchaSiteKey,
                callback: self.onVerify.bind(self), // Verified callback
                "expired-callback": self.onExpired.bind(self), // Expired token callback
            });
        } catch (error) {
            console.error("Error rendering reCAPTCHA:", error);
        }
    }

    onVerify(token) {
        const self = this;
        self.token = token; // Reset the captcha if it expires
    }

    onExpired() {
        const self = this;
        console.warn('reCaptcha expired, re-rendering...');
        self.token = null;
        grecaptcha.reset(this.widgetId);
    }
}
